import { Tooltip, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type SuitabilityTextWithTooltipProps = {
  children: React.ReactNode;
  tooltip: string;
};

export function SuitabilityTextWithTooltip({ children, tooltip }: SuitabilityTextWithTooltipProps) {
  return (
    <Tooltip
      label={tooltip}
      withArrow
      color="black"
      maw={256}
      px="xs"
      py="xxs"
      styles={theme => ({
        tooltip: {
          whiteSpace: 'normal',
          borderRadius: 8,
          backgroundColor: theme.black,
          color: theme.white,
          fontSize: theme.fontSizes.xs,
          fontWeight: FONT_WEIGHTS.semibold,
          padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
        },
        arrow: {
          backgroundColor: theme.black,
        },
      })}
    >
      <Text
        component="span"
        size="sm"
        fw={FONT_WEIGHTS.medium}
        c="brand.6"
        style={{
          cursor: 'help',
          textDecorationLine: 'underline',
          textDecorationStyle: 'dotted',
          textDecorationThickness: '2px',
          textUnderlineOffset: '6px',
        }}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
